module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _vm._l((_vm.productRows), function(row) {
    return _c('div', {
      staticClass: "row"
    }, _vm._l((row), function(product) {
      return _c('div', {
        staticClass: "col-sm-6 col-xs-12 col-md-4 col-lg-3"
      }, [_c('product', {
        attrs: {
          "product": product,
          "track-by": "id"
        }
      })], 1)
    }))
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('b', [_vm._v("Abeja Products")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0963a17c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shop/products/ProductList.vue
// module id = 266
// module chunks = 1